import React, { useEffect, useState } from "react";
import Mainimage from "../../Images/LoginImage2.png";
import Flag from "../../Images/flag2.png";
import axios from "../../axios";
import { useTranslation } from "react-i18next";
import { gapi } from "gapi-script";
import { useNavigate } from "react-router-dom";
import { Riple } from "react-loading-indicators";
import { GoogleLogin } from "@react-oauth/google";
import { toast } from "react-toastify";
import OTPModal from "./OtpModal";
import {
  BadgeCheck,
  ChevronDown,
  Headphones,
  ShieldCheck,
  Sparkles,
  WalletCards,
  Zap,
} from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import Logo from "../../Images/logoIcon.png";

const Signin2 = () => {
  const [t, i18n] = useTranslation();
  const navigate = useNavigate();
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [showActivationScreen, setShowActivationScreen] = useState(false);
  const [videodata, setVideodata] = useState(
    "https://www.youtube.com/watch?v=gACrWBPWsMM",
  );
  const [showmail, setShowmail] = useState(false);
  const [smail, setSmail] = useState("");
  const [dialog, setDialog] = useState({
    title: "Terminated Account",
    message: `Adhyayi is currently down for maintenance. We expect to be back in a couple of hours. Thanks for your patience.`,
  });
  const [signingtitle, setSigningtitle] = useState(false);
  const [terms, setTerms] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mobile, setMobile] = useState("");
  const [isOtpOpen, setIsOtpOpen] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");

  const terminatedAccountDialog = {
    title: "Unable to Login",
    message:
      "Your account is terminated due to violation of our rules. Please contact support  +91 70673 73846 for more information.",
  };

  const showTerminatedAccountPopup = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    setDialog(terminatedAccountDialog);
    setDialogOpen(true);
  };

  const isTerminatedUser = (user) =>
    user?.terminateUser === true ||
    user?.terminateUser === 1 ||
    String(user?.terminateUser).toLowerCase() === "true";

  useEffect(() => {
    function start() {
      gapi.client.init({
        clientId:
          "42381582230-itun71s3lnvhb9f4eaqa2t5sf4idu4ta.apps.googleusercontent.com",
        scope: "email",
      });
    }
    gapi.load("client:auth2", start);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const reason = params.get("reason");

    if (reason === "another_device_login") {
      toast.info(
        "You were logged out because you logged in on another device.",
      );
    }

    const refCode = params.get("ref");
    if (refCode) {
      localStorage.setItem("pendingRefCode", refCode.toUpperCase());
    }
  }, []);

  const getLocationState = async () => {
    try {
      const res = await fetch("https://ipapi.co/json/");
      const data = await res.json();
      return data.region;
    } catch (error) {
      return null;
    }
  };

  const getDeviceInfo = () => {
    const ua = navigator.userAgent.toLowerCase();
    const width = window.innerWidth;

    let deviceType = "laptop";

    if (/ipad|iphone|ipod/.test(ua)) deviceType = "ios";
    else if (width <= 768) deviceType = "mobile";
    else if (width <= 1024) deviceType = "tablet";

    return {
      deviceCategory: deviceType,
      deviceId: crypto.randomUUID(),
      deviceType,
      deviceName: navigator.platform,
    };
  };

  const handleLoginSuccess = async (response) => {
    if (!terms) {
      toast.error("Please agree to the Terms & Conditions to proceed", {
        position: "top-center",
      });
      setIsLoading(false);
      return;
    }

    const tokenId = response?.credential;
    const deviceInfo = getDeviceInfo();
    const IPstate = await getLocationState();
    if (tokenId) {
      axios
        .post("login", {
          token: tokenId,
          platform: "web",
          deviceInfo,
          IPstate,
          loginType: "google",
        })
        .then((response) => {
          const data = response;
          if (data) {
            if (isTerminatedUser(data?.data?.user)) {
              showTerminatedAccountPopup();
              return;
            }

            localStorage.setItem("token", data?.data?.token);
            localStorage.setItem("userId", data?.data?.user?._id);

            // Apply pending referral code after login
            const pendingRefCode = localStorage.getItem("pendingRefCode");
            if (pendingRefCode) {
              axios.defaults.headers.common["Authorization"] = `Bearer ${data?.data?.token}`;
              axios.post("/referral/apply", { referralCode: pendingRefCode })
                .then(() => localStorage.removeItem("pendingRefCode"))
                .catch(() => {});
            }

            if (!data?.data?.user?.onHold && !data?.data?.user?.deleted) {
              if (
                !data?.data?.user?.mobile ||
                data?.data?.user?.mobile?.length === 0
              ) {
                navigate("/login-info");
              } else {
                navigate("/dash");
              }
            } else {
              setDialogOpen(true);
            }
          }
        })
        .catch((err) => {
          const errorCode = err?.response?.data?.code;
          const errorMessage = err?.response?.data?.message || "";

          if (
            errorCode === "ACCOUNT_TERMINATED" ||
            errorMessage.toLowerCase().includes("terminated")
          ) {
            showTerminatedAccountPopup();
            return;
          }

          setDialogOpen(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setDialogOpen(true);
    }
  };

  const handleLoginFailure = () => {
    setIsLoading(false);
  };

  const [googleLoginWidth, setGoogleLoginWidth] = useState(358);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setGoogleLoginWidth(300);
      } else if (window.innerWidth <= 768) {
        setGoogleLoginWidth(330);
      } else {
        setGoogleLoginWidth(400);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const stHinmdi = () => {
    if (i18n.language === "en") {
      i18n.changeLanguage("hi");
      setVideodata("https://www.youtube.com/watch?v=CKx3aQO8CbM");
    } else if (i18n.language === "hi") {
      i18n.changeLanguage("en");
      setVideodata("https://www.youtube.com/watch?v=gACrWBPWsMM");
    }
  };

  const handleSignInClick = () => {
    setIsLoading(true);
    const auth2 = gapi.auth2?.getAuthInstance();
    auth2?.signIn().then(
      (response) => {
        handleLoginSuccess(response);
      },
      (error) => {
        handleLoginFailure(error);
      },
    );
  };

  const handleVerifyOtp = async (otpValue = otp) => {
    if (otpValue.length !== 4) {
      setOtpError("Enter valid 4 digit OTP");
      return;
    }

    try {
      setIsLoading(true);

      await axios.post("/verify-otp", {
        phoneNumber: mobile,
        otp: otpValue,
      });

      const deviceInfo = getDeviceInfo();
      const IPstate = await getLocationState();

      const res = await axios.post("/mobileLogin", {
        mobile,
        platform: "web",
        deviceInfo,
        IPstate,
      });

      const { token, user } = res.data;
      const userId = user?._id || res.data?.userId;

      if (isTerminatedUser(user)) {
        setIsOtpOpen(false);
        showTerminatedAccountPopup();
        return;
      }

      if (token) {
        localStorage.setItem("token", token);
        localStorage.setItem("userId", userId);
        localStorage.setItem("userId", user);
      }

      // Apply pending referral code after mobile login
      const pendingRefCode = localStorage.getItem("pendingRefCode");
      if (pendingRefCode && token) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        axios.post("/referral/apply", { referralCode: pendingRefCode })
          .then(() => localStorage.removeItem("pendingRefCode"))
          .catch(() => {});
      }

      toast.success("Login successful");
      setIsOtpOpen(false);

      if (user?.isFirstTimeLogin) {
        navigate("/dash");
      } else {
        navigate("/login-info");
      }
    } catch (err) {
      const errorCode = err?.response?.data?.code;
      const errorMessage = err?.response?.data?.message || "";

      if (
        errorCode === "ACCOUNT_TERMINATED" ||
        errorMessage.toLowerCase().includes("terminated")
      ) {
        setOtpError("");
        setIsOtpOpen(false);
        showTerminatedAccountPopup();
        return;
      }

      setOtpError(err?.response?.data?.message || "Invalid OTP");
    } finally {
      setIsLoading(false);
    }
  };

  const [resendTimer, setResendTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    if (!isOtpOpen) return;

    setResendTimer(30);
    setCanResend(false);

    const interval = setInterval(() => {
      setResendTimer((timeLeft) => {
        if (timeLeft <= 1) {
          clearInterval(interval);
          setCanResend(true);
          return 0;
        }
        return timeLeft - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isOtpOpen]);

  const handleResendOtp = async () => {
    if (!canResend) return;

    try {
      await axios.post("/generate-otp", { phoneNumber: mobile });
      toast.success("OTP resent");
      setResendTimer(30);
      setCanResend(false);
    } catch {
      toast.error("Failed to resend OTP");
    }
  };

  const handleChangeNumber = () => {
    setIsOtpOpen(false);
    setOtp("");
    setOtpError("");
  };

  const handleRequestOtp = async () => {
    if (!terms) {
      toast.error("Please agree to the Terms & Conditions to proceed", {
        position: "top-center",
      });
      return;
    }

    if (mobile.length !== 10) {
      toast.error("Please enter a valid 10-digit mobile number");
      return;
    }

    try {
      setIsLoading(true);

      await axios.post("/generate-otp", {
        phoneNumber: mobile,
      });

      setOtp("");
      setOtpError("");
      setIsOtpOpen(true);
      toast.success("OTP sent successfully");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to send OTP");
    } finally {
      setIsLoading(false);
    }
  };

  const otpModalProps = {
    phone: mobile,
    value: otp,
    onValueChange: (nextOtp) => {
      setOtp(nextOtp);
      setOtpError("");
    },
    error: otpError,
    resendTimer,
    canResend,
    onResend: handleResendOtp,
    onVerify: handleVerifyOtp,
    onClose: handleChangeNumber,
    onChangeNumber: handleChangeNumber,
    isVerifying: isLoading,
  };

  const isDesktopViewport =
    typeof window !== "undefined" ? window.innerWidth >= 768 : false;

  if (isOtpOpen && !isDesktopViewport) {
    return (
      <OTPModal {...otpModalProps} />
    );
  }

  return (
  <div className="h-[100dvh] overflow-hidden bg-[radial-gradient(circle_at_top,_#f3efff_0%,_#ffffff_42%,_#f7f3ff_100%)] text-[#1d2452]">
    <div className="mx-auto h-full max-w-[1700px] overflow-hidden rounded-[1.5rem] border border-white/70 bg-white/85 shadow-[0_30px_90px_rgba(95,63,170,0.14)] backdrop-blur-sm md:rounded-[2rem]">

      {/* BG EFFECTS */}
      <div className="absolute -left-24 top-[-3rem] h-72 w-72 rounded-full bg-[radial-gradient(circle,_rgba(126,87,255,0.14)_0%,_transparent_68%)]" />

      <div className="absolute right-[-5rem] top-[-2rem] h-80 w-80 rounded-full bg-[radial-gradient(circle,_rgba(255,191,71,0.10)_0%,_transparent_70%)]" />

      <div className="absolute right-8 top-8 hidden grid-cols-4 gap-2 opacity-40 md:grid">
        {Array.from({ length: 12 }).map((_, index) => (
          <span
            key={`login-dot-${index}`}
            className="h-1.5 w-1.5 rounded-full bg-[#cbb6ff]"
          />
        ))}
      </div>

      {/* MOBILE */}
      <div className="relative z-10 flex h-full flex-col px-7 pb-6 pt-20 md:hidden">
        <div className="absolute right-[-110px] top-[-40px] h-72 w-72 rounded-full bg-[#f3ddf8]" />

        <div className="relative z-10 px-1">
          <h1 className="text-[2rem] font-bold leading-none tracking-[-0.02em] text-[#2e2e35]">
            Login Account
          </h1>
          <p className="mt-1 text-[1rem] leading-8 text-[#8b8891]">
            Hello, Welcome Back to our account
          </p>
        </div>

        <div className="relative z-10 mt-4 rounded-[2rem] border border-[#f0ebf7] bg-white/95 px-5 py-6 shadow-[0_18px_35px_rgba(74,44,120,0.12)]">
          <h3 className="text-left text-[1.1rem] font-bold leading-[1.2] text-[#25262b]">
            Enter WhatsApp Number
          </h3>
          <p className="mt-1 text-left text-sm text-[#8b8891]">
            OTP will be delivered on WhatsApp
          </p>

          <div className="mt-4 flex h-[3.5rem] items-center rounded-[1.45rem] border border-[#e7e1ef] bg-white px-4">
            <div className="flex h-11 items-center gap-3 rounded-[0.95rem] bg-[#f6effb] px-4">
              <img
                src={Flag}
                alt="India Flag"
                className="h-5 w-8 rounded-sm object-cover"
              />
              <span className="text-[1.2rem] font-medium leading-none text-[#34323b]">+91</span>
            </div>

            <input
              type="tel"
              placeholder="0123456789"
              value={mobile}
              onChange={(e) => {
                const v = e.target.value.replace(/\D/g, "").slice(0, 10);
                setMobile(v);
              }}
              className="min-w-0 flex-1 border-none bg-transparent pl-4 text-[0.95rem] font-medium text-[#2c2930] outline-none placeholder:text-[#c0bac9] focus:ring-0"
            />
          </div>

          <div className="mt-2 flex items-start rounded-[1.4rem] border border-[#dff4e8] bg-[#eefcf4] px-2 py-2 text-[#245e53]">
            <ShieldCheck className="mt-1 shrink-0 text-[#198c7f]" size={22} />
            <span className="text-sm ">
              Your number is used only for login verification and account security.
            </span>
          </div>

          <div className="mt-4 flex items-start gap-2 bg-gray-50 rounded-[1.4rem] px-2 py-2">
            <input
              type="checkbox"
              id="terms-mobile"
              checked={terms}
              onChange={(e) => setTerms(e.target.checked)}
              className="mt-1 h-5 w-5 shrink-0 rounded-md border-2 border-[#6d3abf]"
            />

            <label
              htmlFor="terms-mobile"
              className="text-sm text-[#78737f]"
            >
              I agree to Adhyayi{" "}
              <a href="/terms-condition" className="text-[#4d2cbe] underline">
                Terms & Conditions
              </a>{" "}
              and{" "}
              <a href="/privacy-policy" className="text-[#4d2cbe] underline">
                Privacy Policy
              </a>
            </label>
          </div>

          <button
            onClick={handleRequestOtp}
            className="mt-4 flex h-[3.9rem] w-full items-center justify-center gap-3 rounded-[1.45rem] bg-[#2fd163] text-[1.1rem] font-bold text-white shadow-[0_16px_30px_rgba(47,209,99,0.28)]"
          >
            <FaWhatsapp size={24} />
            Get OTP on WhatsApp
          </button>
        </div>

        <div className="relative z-10 my-4 flex items-center gap-4 px-2">
          <div className="h-px flex-1 bg-[#ddd8e5]" />
          <span className="text-base text-[#8c8792]">or</span>
          <div className="h-px flex-1 bg-[#ddd8e5]" />
        </div>

 <div className="flex w-full justify-center">
  {!terms ? (
    <button
      onClick={() => {
        toast.error(
          "Please agree to the Terms & Conditions to proceed",
          {
            position: "top-center",
          }
        );
      }}
      style={{ width: googleLoginWidth }}
      className="flex h-[44px] items-center justify-center gap-3 rounded-full border border-[#dadce0] bg-white px-6 text-sm font-medium text-[#3c4043] shadow-sm transition hover:bg-gray-50"
    >
      <img
        src="https://developers.google.com/identity/images/g-logo.png"
        alt="Google"
        className="h-5 w-5"
      />

      <span>Continue with Google</span>
    </button>
  ) : (
    <div className="flex justify-center">
      <GoogleLogin
        onSuccess={handleLoginSuccess}
        onError={handleLoginFailure}
        theme="outline"
        size="large"
        text="continue_with"
        shape="pill"
        width={googleLoginWidth}
      />
    </div>
  )}
</div>
      </div>

      {/* MAIN */}
      <div className="relative z-10 hidden h-full grid-rows-[minmax(0,1fr)_auto] p-4 md:grid md:p-3">
        <div className="flex min-h-0 flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">

          {/* LEFT IMAGE */}
          <div className="hidden flex-1 items-center justify-center lg:flex">
            <img
              src={Mainimage}
              alt="Adhyayi learning illustration"
              className="w-full max-w-[250px] xl:max-w-[430px] object-contain drop-shadow-[0_28px_55px_rgba(95,63,170,0.20)]"
            />
          </div>

          {/* RIGHT LOGIN */}
          <div className="flex w-full items-center justify-center lg:w-[470px] xl:w-[540px] md:mr-24">
            <div className="w-full rounded-[1.5rem] border border-white/80 bg-white/95 p-3 shadow-[0_24px_60px_rgba(95,63,170,0.16)] md:px-5 md:py-4">

              {/* LOGO */}
              <div className="flex items-center gap-3">
                <img
                  src={Logo}
                  alt="Login"
                  className="h-12 w-12 rounded-full object-contain shadow-[0_12px_24px_rgba(95,63,170,0.18)] md:h-14 md:w-14"
                />

                <div>
                  <h2 className="text-lg font-extrabold text-[#18214f] md:text-3xl">
                    Login Account
                  </h2>

                  <p className="mt-1 text-sm text-[#67708f] md:text-base">
                    Hello, Welcome Back
                  </p>
                </div>
              </div>

              {/* MOBILE IMAGE */}
              <div className="mt-2 flex justify-center lg:hidden">
                <img
                  src={Mainimage}
                  alt="mobile login"
                  className="max-h-[110px] object-contain"
                />
              </div>

              {/* FORM */}
              <div className="mt-3 border-t border-[#ebe8f4] pt-4">

                <h3 className="text-xl font-bold text-[#18214f] md:text-2xl">
                  Enter WhatsApp Number
                </h3>

                <p className="mt-1 text-sm text-[#67708f] md:text-base">
                  OTP will be delivered on WhatsApp
                </p>

                {/* INPUT */}
                <div className="mt-3 flex h-12 w-full items-center rounded-[1rem] border border-[#ddd9eb] bg-white px-3 md:h-14">

                  <div className="flex h-10 items-center gap-2 rounded-xl border border-[#efebf8] bg-[#faf7ff] px-2">
                    <img
                      src={Flag}
                      alt="India Flag"
                      className="h-4 w-6 rounded-sm object-cover"
                    />

                    <span className="text-sm font-medium text-[#22284d] md:text-base">
                      +91
                    </span>

                    <ChevronDown
                      size={16}
                      className="text-[#4c5478]"
                    />
                  </div>

                  <input
                    type="tel"
                    placeholder="0123456789"
                    value={mobile}
                    onChange={(e) => {
                      const v = e.target.value
                        .replace(/\D/g, "")
                        .slice(0, 10);

                      setMobile(v);
                    }}
                    className="min-w-0 flex-1 border-none bg-transparent pl-3 text-base text-[#2c2930] outline-none placeholder:text-[#aaa5b0] focus:ring-0 md:text-lg"
                  />
                </div>

                {/* SECURITY */}
                <div className="mt-3 flex items-start gap-2 rounded-[1.2rem] border border-[#dff4e8] bg-[linear-gradient(135deg,#f2fff6_0%,#f4fff9_100%)] px-3 py-2 text-sm leading-6 text-[#27324a]">

                  <ShieldCheck
                    className="mt-0.5 shrink-0 text-[#1f9f91]"
                    size={18}
                  />

                  <span className="text-xs text-[#1f9f91] md:text-sm">
                    Your number is used only for login verification and
                    account security.
                  </span>
                </div>

                {/* TERMS */}
                <div className="mt-3 flex items-start gap-2">
                  <input
                    type="checkbox"
                    id="terms"
                    checked={terms}
                    onChange={(e) => setTerms(e.target.checked)}
                    className="mt-1 h-4 w-4 shrink-0 rounded border-2 border-[#6a35e6]"
                  />

                  <label
                    htmlFor="terms"
                    className="text-xs leading-5 text-[#6a708b] md:text-sm md:leading-6"
                  >
                    I agree to Learn2Earn{" "}
                    <a
                      href="/terms-condition"
                      className="text-[#4d2cbe] underline"
                    >
                      Terms & Conditions
                    </a>{" "}
                    and{" "}
                    <a
                      href="/privacy-policy"
                      className="text-[#4d2cbe] underline"
                    >
                      Privacy Policy
                    </a>
                  </label>
                </div>

                {/* BUTTON */}
                <button
                  onClick={handleRequestOtp}
                  className="mt-3 flex h-12 w-full items-center justify-center gap-2 rounded-[1rem] bg-gradient-to-r from-[#7a42ef] to-[#5d2fd4] text-sm font-bold text-white shadow-[0_18px_34px_rgba(106,53,230,0.28)] transition hover:-translate-y-0.5 md:text-base"
                >
                  <FaWhatsapp size={22} />
                  Get OTP on WhatsApp
                </button>

                {/* DIVIDER */}
                <div className="my-3 flex w-full items-center gap-3">
                  <div className="h-px flex-1 bg-[#dfdbe9]" />

                  <span className="text-sm text-[#77727b]">
                    or
                  </span>

                  <div className="h-px flex-1 bg-[#dfdbe9]" />
                </div>

                {/* GOOGLE */}
      <div className="flex w-full justify-center">
  {!terms ? (
    <button
      onClick={() => {
        toast.error(
          "Please agree to the Terms & Conditions to proceed",
          {
            position: "top-center",
          }
        );
      }}
      style={{ width: googleLoginWidth }}
      className="flex h-[44px] items-center justify-center gap-3 rounded-full border border-[#dadce0] bg-white px-6 text-sm font-medium text-[#3c4043] shadow-sm transition hover:bg-gray-50"
    >
      <img
        src="https://developers.google.com/identity/images/g-logo.png"
        alt="Google"
        className="h-5 w-5"
      />

      <span>Continue with Google</span>
    </button>
  ) : (
    <div className="flex justify-center">
      <GoogleLogin
        onSuccess={handleLoginSuccess}
        onError={handleLoginFailure}
        theme="outline"
        size="large"
        text="continue_with"
        shape="pill"
        width={googleLoginWidth}
      />
    </div>
  )}
</div>

              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM FEATURES */}
        <div className="hidden sm:block gap-3 rounded-[1.3rem] border border-[#efeaf8] bg-white/90 px-4 py-3 shadow-[0_18px_40px_rgba(95,63,170,0.08)] md:grid md:grid-cols-3 md:px-5 md:py-6">

          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-[#f4efff] to-[#efe8ff] text-[#6936e1]">
              <WalletCards size={18} />
            </div>

            <div>
              <h3 className="text-sm font-bold text-[#4d2cbe] md:text-base">
                100% Secure
              </h3>

              <p className="text-xs text-[#646d8a]">
                Your privacy is our priority
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-[#f4efff] to-[#efe8ff] text-[#6936e1]">
              <BadgeCheck size={18} />
            </div>

            <div>
              <h3 className="text-sm font-bold text-[#4d2cbe] md:text-base">
                Trusted Platform
              </h3>

              <p className="text-xs text-[#646d8a]">
                Verified by learners
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-[#f4efff] to-[#efe8ff] text-[#6936e1]">
              <Headphones size={18} />
            </div>

            <div>
              <h3 className="text-sm font-bold text-[#4d2cbe] md:text-base">
                24/7 Support
              </h3>

              <p className="text-xs text-[#646d8a]">
                We’re always here to help
              </p>
            </div>
          </div>

        </div>
        
      </div>

      {isOtpOpen && (
        <div className="absolute inset-0 z-[60] hidden md:block">
          <OTPModal {...otpModalProps} />
        </div>
      )}

      {isDialogOpen && (
        <div className="absolute inset-0 z-[80] flex items-center justify-center bg-black/45 px-4">
          <div className="w-full max-w-sm rounded-2xl bg-white p-6 text-center shadow-2xl">
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-100 text-2xl font-bold text-red-600">
              !
            </div>
            <h2 className="text-xl font-bold text-[#18214f]">
              {terminatedAccountDialog.title}
            </h2>
            <p className="mt-3 text-sm leading-6 text-[#67708f]">
              {terminatedAccountDialog.message}
            </p>
            <button
              type="button"
              onClick={() => setDialogOpen(false)}
              className="mt-6 h-11 w-full rounded-xl bg-[#4B2D83] text-sm font-bold text-white shadow-md"
            >
              Okay
            </button>
          </div>
        </div>
      )}
    </div>
  </div>
);
};

export default Signin2;
